import { connect } from 'react-redux';
import { selectors as flagSelectors } from 'dux/user';
import NavItems from './NavItems';

const mapStateToProps = (state) => ({
  location: state.router.location,
  createString: flagSelectors.createStringSelector(state),
});

export default connect(mapStateToProps, null)(NavItems);
